import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { Grid } from "@mui/material";

import ModalDialog from "../../component/Modal";
import Toaster from "../../component/Toaster";
import { CommonUtil, LoginUserDetails } from "../../util/Utils";

import { dashboardAction } from "../../store/dashboard/dashboardSlice";

import "./dashboard.scss";
import Sms from "./sms";
import Confirm from "./DashboardScrollMessage";
import { Weeks } from "./weeks";
import Birthday from "./birthday";
import Certificate from "./certificate";
import FeesNotePaid from "./feesNotePaid";
import LeadDetails from "./leadDetails";
import NewAdmition from "./newAdmition";
import Significant from "./significant";
import LeadUpdateTracker from "./leadUpdateTracker";
import Feedback from "../sendNotification/Feedback";
import ActiveStudentChart from "./activeStudentChart";
import { useTranslation } from "react-i18next";
import { POPDone } from "./POPDone";
import dayjs from "dayjs";
import { DateTimeUtil } from "../../util/DateTimeUtils";

let modelState: any = undefined;

const Dashboard = () => {
  const { t } = useTranslation();

  const [modalOpen, setModalOpen] = useState(false);
  const [popDoneModalOpen, setPopDoneModalOpen] = useState(false);
  const [smsConsumeAndBalance, setSmsConsumeAndBalance] = useState<any>({});
  const [allActiveStudent, setAllActiveStudent] = useState<any>({});
  const [feedbackList, setFeedbackList] = useState<any>([]);
  const [spinner, setSpinner] = useState<any>(false);
  const [popNotDoneStudentList, setPopNotDoneStudentList] = useState<any>([]);
  const [popInitialValue, setPopInitialValue] = useState<any>([
    { studentId: "", popDone: "" },
  ]);
  const dispatch = useDispatch<any>();
  const dateFormat = process.env.REACT_APP_DEFAULT_DATE_FORMAT;

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = (e: any) => {
    setModalOpen(false);
    openModel();
    modelState = false;
  };

  const handlePopDoneModalOpen = () => {
    setPopDoneModalOpen(false);
  };

  const handlePopDoneModalClose = () => {
    setPopDoneModalOpen(false);
    modelState = false;
  };

  const loginUserName: any = useState<string>(
    LoginUserDetails.getUserDetails().username as string
  );

  const currentFranchiseeId = LoginUserDetails.getUserDetails()?.franchiseeId;

  const getSMSConsumeAndBalance = () => {
    dispatch(dashboardAction({ apiAction: "getSMSConsumeAndBalance" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          let sortedSMSData = Object.fromEntries(
            Object.entries(result?.payload?.data?.data).sort(([a], [b]) => {
              const dateA = new Date(a);
              const dateB = new Date(b);
              return dateA?.getTime() - dateB?.getTime();
            })
          );
          setSmsConsumeAndBalance(sortedSMSData);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const getAllActiveStudent = () => {
    dispatch(dashboardAction({ apiAction: "getAllActiveStudent" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setAllActiveStudent(result?.payload?.data?.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (modelState === undefined) handleModalOpen();
  });

  const openModel = () => {
    setSpinner(true);
    dispatch(dashboardAction({ apiAction: "popNotDoneStudentList" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setPopNotDoneStudentList(
            CommonUtil?.formateDropdownList(
              result?.payload?.data?.data,
              "studentName"
            )
          );
          if (result?.payload?.data?.data?.length > 0) {
            handlePopDoneModalOpen();
          }
          setPopInitialValue(
            [...result?.payload?.data?.data]?.map((item: any) => {
              return {
                studentName: item?.studentName,
                studentId: item?.id,
                popDone: "No",
              };
            })
          );
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setSpinner(false);
      });
  };

  useEffect(() => {
    getSMSConsumeAndBalance();
    getAllActiveStudent();
  }, []);

  useEffect(() => {
    getFeedbackList();
  }, [currentFranchiseeId]);

  const getFeedbackList = () => {
    dispatch(
      dashboardAction({
        apiAction: "feedbackList",
        franchiseeId: { franchiseeId: currentFranchiseeId },
      })
    )
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setFeedbackList(result?.payload?.data?.data);
          console.log(result?.payload?.data?.data?.FeedbackList);
          if (result?.payload?.data?.data?.FeedbackList) {
            console.log(result?.payload?.data?.data?.FeedbackList[0]);
          }
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const checkFeedbackModal = (feedbackData: any) => {
    if (
      feedbackData &&
      dayjs(
        DateTimeUtil.format(feedbackData[0]?.toDate, dateFormat, true)
      )?.isAfter(dayjs()) &&
      dayjs(
        DateTimeUtil.format(feedbackData[0]?.fromDate, dateFormat, true)
      )?.isBefore(dayjs())
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="module-container">
      <div className="sub-module-header color-sec">
        Welcome! {loginUserName}
      </div>
      <Grid
        container
        spacing={2}
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 2 }}
        className="padding-up-25"
      >
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <div className="mainBox">
            <ActiveStudentChart />
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <div className="mainBox">
            <Significant />
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={5}>
          <div className="mainBox">
            <NewAdmition />
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 2 }}
        className="padding-up-25"
      >
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <div className="mainBox">
            <Weeks />
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <div className="mainBox">
            <Birthday />
          </div>
        </Grid>
        <Grid item xs={12} sm={5} md={5} lg={5}>
          <div className="mainBox">
            <Certificate />
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 2 }}
        className="padding-up-25"
      >
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <div className="lastBox">
            <FeesNotePaid allActiveStudent={allActiveStudent} />
          </div>
          <div className="lastBox">
            <Sms smsConsumeAndBalance={smsConsumeAndBalance} />
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} p={2.5}>
          <div className="mainBox">
            <LeadUpdateTracker />
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 2 }}
        className="padding-up-25"
      >
        <Grid item xs={12} sm={6} md={6} lg={12}>
          <div className="mainBox lead">
            <LeadDetails />
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={12}
          style={{ paddingLeft: "30px" }}
        >
          <Confirm />
        </Grid>
      </Grid>
      {checkFeedbackModal(feedbackList?.FeedbackList) && (
        <ModalDialog
          state={modalOpen}
          title={"Feedback"}
          screenName={"dashboard"}
          closeButtonHide={true}
          onClose={handleModalClose}
          backdrop={false}
          size="m"
          content={
            <Feedback close={handleModalClose} feedbackList={feedbackList} />
          }
        ></ModalDialog>
      )}

      {/* POP done pop-up */}
      <ModalDialog
        state={popDoneModalOpen}
        title={t("popDone")}
        onClose={handlePopDoneModalClose}
        size="mn"
        content={
          <POPDone
            spinner={spinner}
            setSpinner={setSpinner}
            popNotDoneStudentList={popNotDoneStudentList}
            setPopNotDoneStudentList={setPopNotDoneStudentList}
            popInitialValue={popInitialValue}
            setPopInitialValue={setPopInitialValue}
            handlePopDoneModalClose={handlePopDoneModalClose}
          />
        }
      />
    </div>
  );
};

export default Dashboard;
